import script from "./OptionWordBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionWordBlock.vue?vue&type=script&setup=true&lang=js"

import "./OptionWordBlock.vue?vue&type=style&index=0&id=5b55e046&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b55e046"]])

export default __exports__